/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 11L9 8M6 11L9 14M6 11H13.2C14.8802 11 15.7202 11 16.362 11.327C16.9265 11.6146 17.3854 12.0735 17.673 12.638C18 13.2798 18 14.1198 18 15.8V16.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 11L9 8M6 11L9 14M6 11H13.5C15.9853 11 18 13.0147 18 15.5V15.5V16.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM9.53033 8.53025C9.82322 8.23736 9.82322 7.76248 9.53033 7.46959C9.23744 7.1767 8.76256 7.1767 8.46967 7.46959L5.46967 10.4696C5.17678 10.7625 5.17678 11.2374 5.46967 11.5302L8.46967 14.5302C8.76256 14.8231 9.23744 14.8231 9.53033 14.5302C9.82322 14.2374 9.82322 13.7625 9.53033 13.4696L7.81066 11.7499H13.2C14.0525 11.7499 14.6467 11.7505 15.1093 11.7883C15.5632 11.8254 15.824 11.8945 16.0215 11.9952C16.4448 12.2109 16.789 12.5551 17.0048 12.9784C17.1054 13.176 17.1745 13.4367 17.2116 13.8906C17.2494 14.3532 17.25 14.9475 17.25 15.7999V16C17.25 16.4142 17.5858 16.75 18 16.75C18.4142 16.75 18.75 16.4142 18.75 16V15.7999V15.7678C18.75 14.955 18.75 14.2994 18.7066 13.7684C18.662 13.2218 18.5676 12.7417 18.3413 12.2975C17.9818 11.5918 17.4081 11.0182 16.7025 10.6586C16.2582 10.4323 15.7781 10.3379 15.2315 10.2933C14.7006 10.2499 14.0449 10.2499 13.2321 10.2499H13.2H7.81066L9.53033 8.53025Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M6 11L9 8M6 11L9 14M6 11H13.5C15.9853 11 18 13.0147 18 15.5V15.5V16.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 11L9 8M6 11L9 14M6 11H13.5C15.9853 11 18 13.0147 18 15.5V15.5V16.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.53033 7.46967C9.82322 7.76256 9.82322 8.23744 9.53033 8.53033L7.81066 10.25H13.2H13.2321C14.0449 10.25 14.7006 10.25 15.2315 10.2934C15.7781 10.338 16.2582 10.4324 16.7025 10.6587C17.4081 11.0183 17.9817 11.5919 18.3413 12.2975C18.5676 12.7418 18.662 13.2219 18.7066 13.7685C18.75 14.2994 18.75 14.955 18.75 15.7679V15.8V16.0001C18.75 16.4143 18.4142 16.7501 18 16.7501C17.5858 16.7501 17.25 16.4143 17.25 16.0001V15.8C17.25 14.9475 17.2494 14.3533 17.2116 13.8907C17.1745 13.4368 17.1054 13.176 17.0048 12.9785C16.789 12.5552 16.4448 12.211 16.0215 11.9952C15.824 11.8946 15.5632 11.8255 15.1093 11.7884C14.6467 11.7506 14.0525 11.75 13.2 11.75H7.81066L9.53033 13.4697C9.82322 13.7626 9.82322 14.2374 9.53033 14.5303C9.23744 14.8232 8.76256 14.8232 8.46967 14.5303L5.46967 11.5303C5.17678 11.2374 5.17678 10.7626 5.46967 10.4697L8.46967 7.46967C8.76256 7.17678 9.23744 7.17678 9.53033 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
